// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressInfoDisplayStyles } from "@eisinc/Overrides/Components/AddressInfoDisplay";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const addressTextStyle: TypographyPresentationProps = {
    size: fontConfig.small.size,
    lineHeight: fontConfig.small.lineHeight,
    weight: fontConfig.weight.regular,
}

addressInfoDisplayStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 2px;
        font-style: normal;
    `
}

addressInfoDisplayStyles.customerNameText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.firstNameText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.lastNameText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.attentionText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.companyNameText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.address1Text = {
    ...addressTextStyle
}

addressInfoDisplayStyles.address2Text = {
    ...addressTextStyle
}

addressInfoDisplayStyles.address3Text = {
    ...addressTextStyle
}

addressInfoDisplayStyles.address4Text = {
    ...addressTextStyle
}

addressInfoDisplayStyles.cityStatePostalCodeText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.cityText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.stateText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.postalCodeText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.countryText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.phoneText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.emailText = {
    ...addressTextStyle
}

addressInfoDisplayStyles.faxText = {
    ...addressTextStyle
}
